import { type FC } from 'react';
import { Stack } from '@mantine/core';
import { type PayinTicket } from '~/entities/payin';
import { PayinTicketStatus } from '~/entities/payin';
import { ResolveTicket } from '../actions';
import { TicketDetails } from '../components/TicketDetails';

interface ManageTicketProps {
    ticket: PayinTicket;
    onReslove?: () => void;
    onError?: () => void;
}

export const ManageTicket: FC<ManageTicketProps> = ({ ticket, onReslove, onError }) => {
    const resolveEnabled = ticket.status === PayinTicketStatus.STATUS_CREATED;

    return (
        <Stack>
            <TicketDetails ticket={ticket} />

            {resolveEnabled && (
                <ResolveTicket
                    id={ticket.id?.value}
                    onSuccess={onReslove}
                    onError={onError}
                />
            )}
        </Stack>
    );
};
